import React, { useEffect, useState } from 'react'
import { connect, useDispatch, useSelector } from 'react-redux'
import { BrowserRouter } from 'react-router-dom'
import { Watchdog } from '@Techedge/smart-shared'
import SmartSidebar from './components/smart-sidebar/smart-sidebar'
import {
    ability,
    AbilityContext,
    AppState,
    layoutActions,
    permissionsActions,
    UserHelper,
} from '@Techedge/digitalportal-shared'
import './App.scss'
import { IntlProvider } from 'react-intl'
import { SidebarServices } from './services/SidebarServices'

export const App = (props: any) => {
    const dispatch = useDispatch()
    const hasSocialHubEnabled = useSelector(
        (state: AppState) => state.userReducer.user.phase3_enabled
    )
    const [locale, setLocale] = useState<string>('en-US')
    const [messages, setMessages] = useState<Record<string, string> | null>(
        null
    )

    useEffect(() => {
        if (
            (!props.permissions || !props.permissions.length) &&
            props.token &&
            window.location.hostname.includes('smartly') &&
            !!props.user?.user_id
        ) {
            UserHelper._shared().getSmartlyPermissions(props.user)
            if (hasSocialHubEnabled) {
                SidebarServices.GetSocialHubConfiguration().then(({ data }) => {
                    dispatch(layoutActions.setSocialHubConfiguration(data))
                })
            }
        }
    }, [props.token, props.user.user_id])

    useEffect(() => {
        if (props.language && props.dictionary) {
            setLocale(props.language)
            setMessages(props.dictionary)
        }
    }, [props.language, props.dictionary])

    return (
        <IntlProvider locale={locale} messages={messages}>
            <AbilityContext.Provider value={ability}>
                <BrowserRouter>
                    {!!messages && (
                        <Watchdog
                            providerName="SIDEBAR"
                            userProfile={props.userProfiles[0]?.profile}>
                            <SmartSidebar {...props} />
                        </Watchdog>
                    )}
                </BrowserRouter>
            </AbilityContext.Provider>
        </IntlProvider>
    )
}

const mapStateToProps = (state: any) => ({
    token: state.userReducer.accessToken,
    language: state.userReducer.user.language,
    dictionary: state.userReducer.user.dictionary,
    userProfiles: state.userReducer.user.application_profiles || [],
    permissions: state.permissionsReducer.actions,
    user: state.userReducer.user,
})
// TODO permission è ora la response di /portals (non chiaro dove viene detto)
//      rinominarlo e collegare la response di /permission per mostrare il profile mgmt
const mapDispatchToProps = (dispatch: any) => ({
    getActions: () => dispatch(permissionsActions.getActions()),
})

export default connect(mapStateToProps, mapDispatchToProps)(App)
